<app-time
  [userId]="userId"
  [interval]="INTERVAL"
  [timeFormControlParams]="timeFormControlParams"
  (formValuesChanged)="onFormValuesChanged($event)"
  (intervalChanged)="onIntervalChanged($event)"
></app-time>